<!--
  File name: PBNEFBreadCrumbs.vue
  Program Description:
    - This components includes the DBN number and breadcrubs divider
    - This component is used to different pages in PBNEF that needs the DBN header
-->
<template>
  <v-row
    align-self="start"
    justify="center"
  >
    <v-col>
      <v-card
        class="transparent-bg"
        tile
        elevation="0"
      >
        <v-card-title class="pl-0 pb-0">
          <h2>
            <b> {{ dbnNumber }} - PBNEF {{ !isSubmitted ? 'Drafts' : '' }}</b>
          </h2>
          <v-spacer />
          <v-breadcrumbs
            large
            :items="breadcrumbs.items"
            :divider="breadcrumbs.divider"
          />
        </v-card-title>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { mapFields } from 'vuex-map-fields'

export default {
  name: 'PBNEF',
  computed: {
    ...mapFields('pbnef', {
      dbnNumber: 'dbnNumber',
      docketNumber: 'docketNumber',
      $meta: '$meta',
      isSubmitted: 'isSubmitted'
    }),
    breadcrumbs () {
      return {
        divider: '>',
        large: true,
        items: [
          { text: 'PDBNF' },
          {
            text: `${this.dbnNumber} - PBNEF${!this.isSubmitted ? ' Drafts ' : ''}`,
            to: '#'
          }
        ]
      }
    }
  }
}
</script>

<style scoped>
.v-breadcrumbs >>> a{
  color: #162b54 !important;
  font-weight: bolder;
  cursor: default;
}
.v-breadcrumbs{
  font-weight: bolder;
}

.transparent-bg {
  background-color: rgba(0,0,0,0);
}
</style>
